export const GET_PURPOSE = 'PURPOSE/get_purpose';
export const GET_SINGLE_PURPOSE = 'PURPOSE/GET_SINGLE_PURPOSE';
export const UPDATE_PURPOSE = 'PURPOSE/update_purpose';
export const CREATE_PURPOSE = 'PURPOSE/create_purpose';
export const REMOVE_PURPOSE = 'PURPOSE/remove_purpose';
export const ACTIVATE_PURPOSE = 'PURPOSE/activate_purpose';
export const DEACTIVATE_PURPOSE = 'PURPOSE/deactivate_purpose';
export const GET_TAG = 'PURPOSE/get_tag';
export const REMOVE_TAG = 'PURPOSE/remove_tag';
export const TAG = 'PURPOSE/tag';
export const GET_APPLICATION_STATUS = 'PURPOSE/get_applicantion_status';

export const FORM_DATA = {
  name: '',
  with_country_code: 0,
  for_birth_certificate: 0,
  for_death_certificate: 0,
  for_marriage_certificate: 0,
};
